// IE 2026 10 23 / ODOO-5800 (ie-dm7): флажки в заголовках строк грида (колонка `use` и bool-колонки position='rowHeaders' / positionNew) —
// умолчание «ключа нет = включено» только ПОКАЗЫВАЕТСЯ и в данные строк не пишется. Раньше AttrGrid.rowHeaders() при отрисовке писал true
// в каждую строку без ключа через store.set_value → record._meta.modified = true у всех строк списка без правки пользователя.
// Выключатель fe.ux.rhBoolImplicitDefault (по умолчанию включён): false — прежнее поведение (запись умолчания при отрисовке).
// Запись умолчания в НОВУЮ строку (действие пользователя «добавить строку») не затрагивается.

export const RH_BOOL_FLAG = 'fe.ux.rhBoolImplicitDefault'

// умолчание ПОКАЗА флажка (та же логика, что была у записи в rowHeaders()): колонка use — true; колонка прежнего фронта
// position='rowHeaders' — true; флажок по positionNew — только заданное attr.default (без default — undefined, снят, как раньше)
export function rhBool_default(attr, isUseColumn) {
    if (isUseColumn) return true
    if (attr?.position === 'rowHeaders') return true
    return attr?.default
}

// состояние флажка: нет значения (null / undefined) — умолчание def, иначе значение строки
export function rhBool_checked(value, def) {
    return value == null ? !!def : !!value
}

// флаг включён (по умолчанию) — умолчание в строки не пишется; false — прежнее поведение (запись)
export function rhBool_implicit(settingValue) {
    return settingValue !== false
}
